import CompanyDashboard from '@/components/company/CompanyDashboard';

export default [
  {
    path: '/company',
    name: 'Company',
    meta: { requiresAuth: true, action: 'view', subject: 'company' },
    component: CompanyDashboard,
  },
];



// WEBPACK FOOTER //
// ./src/router/company.js